/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactNote } from './ContactNote';
import {
    ContactNoteFromJSON,
    ContactNoteFromJSONTyped,
    ContactNoteToJSON,
    ContactNoteToJSONTyped,
} from './ContactNote';

/**
 * 
 * @export
 * @interface ContactNoteResponse
 */
export interface ContactNoteResponse {
    /**
     * 
     * @type {Array<ContactNote>}
     * @memberof ContactNoteResponse
     */
    contactList?: Array<ContactNote>;
}

/**
 * Check if a given object implements the ContactNoteResponse interface.
 */
export function instanceOfContactNoteResponse(value: object): value is ContactNoteResponse {
    return true;
}

export function ContactNoteResponseFromJSON(json: any): ContactNoteResponse {
    return ContactNoteResponseFromJSONTyped(json, false);
}

export function ContactNoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactNoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contactList': json['contactList'] == null ? undefined : ((json['contactList'] as Array<any>).map(ContactNoteFromJSON)),
    };
}

export function ContactNoteResponseToJSON(json: any): ContactNoteResponse {
    return ContactNoteResponseToJSONTyped(json, false);
}

export function ContactNoteResponseToJSONTyped(value?: ContactNoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactList': value['contactList'] == null ? undefined : ((value['contactList'] as Array<any>).map(ContactNoteToJSON)),
    };
}

